import React from 'react'

const AnalyticsChartSkeleton = ({ height = 300 }) => {
    return (
        <div style={{ position: 'relative', paddingLeft: 50 }}>
            {/* Y-axis label skeleton */}
            <div
                className="absolute left-0 bottom-0 rotate-180 text-center text-[#d1d0e1] pt-[140px] pb-[20px] select-none"
                style={{ writingMode: 'vertical-rl', width: 24, height: height }}
            >
                <div className="h-32 w-4 bg-lightBG rounded opacity-50 mx-auto"></div>
            </div>
            {/* Main chart area skeleton */}
            <div className="w-full">
                <div className="bg-lightBG rounded-[10px] animate-pulse" style={{ height: height, width: '100%' }}></div>
                {/* Mini chart brush skeleton */}
                <div className="bg-lightBG rounded-[10px] mt-[40px] animate-pulse" style={{ height: 60, width: '100%' }}></div>
            </div>
        </div>
    )
}

export default AnalyticsChartSkeleton
